import { DatasimPrincing } from "./DatasimPricing";

export class Datasim {
    id: number|null;
    productOption: String;
    hasVoiceOption: boolean;
    costMonthly: number;
    costUnique: number;
    quantity: number;
  
    constructor() {
      this.id = null
      this.productOption = '';
      this.costUnique = 0;
      this.costMonthly = 0;
      this.hasVoiceOption = false;
      this.quantity = 0;
    }

    static fromPriceList(price: DatasimPrincing) : Datasim  {
      var datasim = new Datasim()
      datasim.costMonthly = price.costMonthly
      datasim.costUnique = price.costUnique
      datasim.productOption = price.productOption
      datasim.quantity = 1

      return datasim
    }
}


// WEBPACK FOOTER //
// ./src/models/Datasim.ts